import React from "react";

interface TabButtonProps {
    tab: string;
    activeTab: string;
    onClick: (tab: string) => void;
    children: React.ReactNode;
}

const DecisionPointTabs = ({ tab, activeTab, onClick, children }: TabButtonProps) => (
    <div className="pr-2 min-w-48">
        {" "}
        <button
            onClick={() => onClick(tab)}
            className={`px-4 py-2 ${activeTab === tab ? "bg-blue-400 text-white" : "bg-gray-300 text-gray-700"} tab-button-hover2 p-4 w-48 `}
        >
            {children}
        </button>
    </div>
);

export default DecisionPointTabs;
